var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24043 4.08L6.81043 2.65C4.41043 4.48 2.83043 7.3 2.69043 10.5H4.69043C4.84043 7.85 6.20043 5.53 8.24043 4.08ZM20.6304 10.5H22.6304C22.4804 7.3 20.9004 4.48 18.5104 2.65L17.0904 4.08C19.1104 5.53 20.4804 7.85 20.6304 10.5ZM18.6604 11C18.6604 7.93 17.0204 5.36 14.1604 4.68V4C14.1604 3.17 13.4904 2.5 12.6604 2.5C11.8304 2.5 11.1604 3.17 11.1604 4V4.68C8.29043 5.36 6.66043 7.92 6.66043 11V16L4.66043 18V19H20.6604V18L18.6604 16V11ZM12.6604 22C12.8004 22 12.9304 21.99 13.0604 21.96C13.7104 21.82 14.2404 21.38 14.5004 20.78C14.6004 20.54 14.6504 20.28 14.6504 20H10.6504C10.6604 21.1 11.5504 22 12.6604 22Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreAlarm);
export default __webpack_public_path__ + "static/media/icon-more-alarm.316b249a9790580146f40679ba5d50ec.svg";
export { ForwardRef as ReactComponent };